import { GRADE_LEVEL_LABEL } from '../enums/grade-level.enum'

export const VariationsOfKinder: string[] = [GRADE_LEVEL_LABEL.K, GRADE_LEVEL_LABEL.KIN, GRADE_LEVEL_LABEL.KINDER]
